<template>
    <section id="sectionPrincipal" class="catalog-forecast-market" v-if="hasAccessRead(FUNCTIONALITY, [APPLICATION.CATALOG_FORECAST_ID])">
        <Loader v-if="loading" :loading="loading" :fixed="true"></Loader>
        <template v-if="periodHasZones.length && periodHasZone">
            <component
                v-if="props"
                is="CatalogForecastMarket"
                v-bind="props"
                @reload="loadPeriodHasZone"
                @change="changePeriod"
                @updateIsEdit="updateIsEdit"
            ></component>
        </template>
        <template v-else>
            <div class="no-period">{{ $t("catalogForecast.market.noPeriod") }}</div>
        </template>
    </section>
</template>
<script>
import CatalogForecastMarket from "@/components/catalogForcast/elements/CatalogForecastMarket";
import Loader from "@/components/loader/loader";
import { FUNCTIONALITY } from "@/components/catalogForcast/constants";
import periodHasZoneService from "@/services/cfPeriodHasZones";
import categorieService from "@/services/categories";
import { APPLICATION, APPLICATION_PARAMETER } from "@/components/admin/brand/constant";
import brandApplicationHasParametersService from "@/services/brandApplicationHasParameters";

export default {
    components: { CatalogForecastMarket, Loader },
    data() {
        return {
            APPLICATION,
            APPLICATION_PARAMETER,
            props: null,
            FUNCTIONALITY,
            loading: true,
            periodHasZones: [],
            periodHasZone: null,
            categories: [],
            filters: new Map(),
            paramAddImagesToArticles: null,
            isEditing: false
        };
    },
    computed: {},
    methods: {
        async loadPeriodHasZone(pzId) {
            this.loading = true;
            this.periodHasZone = await periodHasZoneService.get(pzId ? pzId : this.$route.params.id);
            this.periodHasZones = await periodHasZoneService.getAllForMarket(this.periodHasZone.zone.id);
            this.filters.set("pzId", this.periodHasZone.id);
            this.loadProps();
            this.loading = false;
        },
        changePeriod(periodHasZone) {
            this.loadPeriodHasZone(periodHasZone.id);
            this.$router.push({ path: "/admin/catalog_forecast/market/" + periodHasZone.id });
        },
        updateIsEdit(value) {
            this.isEditing = value;
            this.loadProps();
        },
        loadProps() {
            this.props = {
                key: this.periodHasZone.id,
                periodHasZone: this.periodHasZone,
                periodHasZones: this.periodHasZones,
                filters: this.filters,
                categories: this.categories,
                paramAddImagesToArticles: this.paramAddImagesToArticles,
                isEditing: this.isEditing,
                reload: true
            };
        },
        warningSaveQuantities() {
            if (!this.isEditing) {
                return new Promise(resolve => resolve(true));
            }
            return this.$swal({
                html: this.$t("catalogForecast.market.warningSave"),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "red",
                confirmButtonText: this.$t("common.yes").toUpperCase(),
                cancelButtonText: this.$t("common.no").toUpperCase(),
                closeOnConfirm: true
            });
        }
    },
    async created() {
        this.loading = true;
        this.paramAddImagesToArticles = await brandApplicationHasParametersService.findByBrandAndApplicationAndParameter(
            APPLICATION.CATALOG_FORECAST_ID,
            APPLICATION_PARAMETER.ADD_IMAGES_TO_ARTICLES_ID
        );
        this.categories = await categorieService.getAll();
        await this.loadPeriodHasZone();
        this.loading = false;
    },
    async beforeRouteLeave(to, from, next) {
        if (!this.isEditing) {
            next();
        } else {
            if (await this.warningSaveQuantities()) {
                next();
            } else {
                next(false);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.catalog-forecast-market {
    background-color: #fff;
    margin-top: 30px;
    .no-period {
        font-size: 16px;
        padding: 50px;
        display: flex;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// CatalogForecastMarketFromDashboard.vue?3215f46c